export default "__VITE_ASSET__CV_qG_vz__"